import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Country, EmpHomeContactType } from '../../data';

import { useSxStyles } from './useStyles';

type Props = {
  data: EmpHomeContactType;
  countryList: Country[];
};

export const HomeContactReadMode = ({ data: emp, countryList }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const nationality = countryList?.find(
    (country) => country.code === emp?.fEmpCountry,
  );
  return (
    <div>
      <Box component="table" sx={sxStyles.table}>
        <tbody>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpPhoneHome')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpPhoneHome ? emp?.fEmpPhoneHome : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpEmailHome')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpEmailHome ? emp?.fEmpEmailHome : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpStreetAddress1')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpStreetAddress1 ? emp?.fEmpStreetAddress1 : '')}
            </Box>
          </tr>
          {emp?.fEmpStreetAddress2 ? (
            <tr>
              <Box component="td" sx={sxStyles.labelReadMode}>
                {t('fEmpStreetAddress2')}
              </Box>
              <Box component="td" sx={sxStyles.valReadMode}>
                {': ' +
                  (emp?.fEmpStreetAddress2 ? emp?.fEmpStreetAddress2 : '')}
              </Box>
            </tr>
          ) : null}
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpCity')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpCity ? emp?.fEmpCity : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpPostalCode')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpPostalCode ? emp?.fEmpPostalCode : '')}
            </Box>
          </tr>
          <tr>
            <Box component="td" sx={sxStyles.labelReadMode}>
              {t('fEmpCountry')}
            </Box>
            <Box component="td" sx={sxStyles.valReadMode}>
              {': ' + (emp?.fEmpCountry ? nationality?.name || '' : '')}
            </Box>
          </tr>
        </tbody>
      </Box>
    </div>
  );
};
